import { Box, Typography } from '@mui/material';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import placeholderImage from '../../../assets/course/certificate.png';
import CurvedArrow from '../../../assets/course/curvedArrow.svg';
import {
	borderRadius,
	cardDimensionsMedia,
	palette,
	spaces,
} from '../../../assets/styles/themes/tokens';
import useScreenSize from '../../../utils/useScreenSize';
import CourseCoverButton from './CourseCoverButton';
import { CourseCoverPageContext } from './CourseCoverPageProvider';

const CourseCoverPageCertificatesBanner = () => {
	const { t } = useTranslation();
	const { isXsScreen, isLgScreen } = useScreenSize();
	const { isLoading } = useContext(CourseCoverPageContext);

	if (isLoading) return <></>;

	return (
		<Box
			sx={{
				width: '100%',
				padding: spaces.lg,
				maxWidth: cardDimensionsMedia.desktop.maxWidth,
				backgroundColor: palette.primary.contrastText,
				borderRadius: borderRadius.lg,
				position: 'relative',
				display: 'flex',
				gap: spaces.md,
				flexDirection: isXsScreen ? 'column' : 'row',
				alignItems: 'center',
			}}
		>
			<Box
				sx={{
					display: 'flex',
					flexDirection: 'column',
					gap: spaces.lg,
				}}
			>
				<Box
					sx={{
						display: 'flex',
						flexDirection: 'column',
						gap: spaces.xs,
						maxWidth: isLgScreen ? 540 : undefined,
					}}
				>
					<Typography variant="h6" sx={{ color: palette.secondary.main }}>
						{t('Receive a certificate')}
					</Typography>
					<Typography variant="body2" sx={{ color: palette.secondary.main }}>
						{t('Add this qualification to your LinkedIn profile, resume or CV.')}
					</Typography>
				</Box>
				<CourseCoverButton coverPageSection="certificate" />
			</Box>
			<Box
				sx={{
					position: isLgScreen ? 'absolute' : 'relative',
					right: isLgScreen ? 60 : 0,
					bottom: isLgScreen ? 27 : 0,
					paddingLeft: '76px',
					paddingBottom: isXsScreen ? '22px' : 0,
					width: 'fit-content',
				}}
			>
				<Box
					component={CurvedArrow}
					sx={{
						color: palette.primary.main,
						width: 176,
						height: 79,
						position: 'absolute',
						bottom: isXsScreen ? `-${spaces.xs}` : `-${spaces.xl}`,
						left: 0,
					}}
				/>
				<Box
					component="img"
					src={placeholderImage}
					sx={{
						height: 175,
						width: 221,
						background: palette.background.paperElevation2,
						borderRadius: borderRadius.md,
					}}
				/>
			</Box>
		</Box>
	);
};

export default CourseCoverPageCertificatesBanner;
